import React from 'react';
import { Link } from 'react-router-dom';
import styles from './mudancaMei.module.css'; 

function mudancaMei() {
  return (
    <div className={styles.paginaMateria}>
      <div className={styles.containerInterno}>
        
        <Link to="/blog" className={styles.btnVoltar}>
          &larr; Voltar para o Portal
        </Link>

        <header className={styles.cabecalhoMateria}>
          <span className={styles.tagMateria}>Informativo Tributário</span>
          <h1>Alterações nas regras do MEI: Novo Limite de Faturamento e Perdão de Dívidas</h1>
          <p className={styles.subtitulo}>A Lei Complementar nº 238/2026 trouxe novidades importantes para o Microempreendedor Individual (MEI), incluindo o aumento do limite de faturamento anual, a possibilidade de contratação de até 2 empregados e o perdão de dívidas tributárias da União.</p>
          <span className={styles.dataPublicacao}>Publicado em 22 de Outubro de 2026</span>
        </header>

        <article className={styles.conteudoTexto}>
          <p>
            A Lei Complementar nº 238/2026 (DOU de 21.10.2026 – edição extra) promoveu alterações na Lei Complementar nº 123/2006, estabelecendo novas regras para o microempreendedor individual (MEI).
          </p>

          <h2>1. Aumento do limite de faturamento anual do MEI</h2>
          <p>
            O limite de receita bruta para enquadramento como MEI terá um aumento progressivo a partir de 2027:
          </p>
          <ul>
            <li><strong>Até 2026:</strong> O limite de faturamento anual permanece em R$ 81.000,00 (Média mensal: R$ 6.750,00).</li>
            <li><strong>2027:</strong> O limite anual passará para R$ 110.000,00 (Média mensal: R$ 9.166,67).</li>
            <li><strong>A partir de 2028:</strong> O limite anual será de R$ 140.000,00 (Média mensal: R$ 11.666,67).</li>
          </ul>

          <h2>2. Possibilidade de contratação de até 2 empregados</h2>
          <p>
            A partir de 2027, o MEI poderá contratar até 2 empregados, desde que eles recebam exclusivamente 1 salário-mínimo ou o piso salarial da categoria profissional.
          </p>
          <p>
            No caso de afastamento legal de qualquer empregado, será permitida a contratação de substitutos, inclusive por prazo determinado.
          </p>

          <h2>3. Perdão de dívidas tributárias (da União)</h2>
          <p>
            A norma concedeu perdão integral (remissão) dos débitos tributários da União, inscritos ou não em Dívida Ativa, existentes até 13.10.2026, de responsabilidade do MEI. O perdão inclui o tributo principal, multas e juros.
          </p>
          <p>
            <strong>Atenção:</strong> O benefício não inclui os débitos de ICMS e ISS cobrados no DAS-SIMEI, cujas regras dependem de cada Estado ou Município.
          </p>
          <p>
            Para manter o benefício do perdão das dívidas, o MEI deverá manter o pagamento em dia da contribuição mensal do DAS-SIMEI por 6 meses (de novembro de 2026 a abril de 2027).
          </p>

          <h2>4. Novos Limites para Licitação Pública</h2>
          <p>
            O limite para licitação com o poder público (União, Estados e Municípios) destinado a microempresas (ME) e empresas de pequeno porte (EPP) aumentou para R$ 100.000,00. O MEI poderá participar de licitações de valor até R$ 25.000,00.
          </p>

          <hr className={styles.linhaDivisoria} />

          <p className={styles.textoDestaqueAcao}>
            Ficou com alguma dúvida sobre as novas regras do MEI ou precisa de apoio para regularizar a situação da sua empresa? A equipe da CPP Contabilidade está à disposição para auxiliar.
          </p>
        </article>

      </div>
    </div>
  );
}

export default mudancaMei;